// @flow

export const autoMessagePollingInterval = 3 * 1000;

export const statusToTextBadge = {
  draft: {
    textColor: 'white',
    color: 'eclipse',
  },
  inactive: {
    textColor: 'white',
    color: 'sunrise',
  },
  active: {
    textColor: 'white',
    color: 'shamrock',
  },
};
